/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  BackOfficeSite,
  BlockContext,
  BlockReason,
  CustomDomainInfo,
  CustomHostname,
  Index,
  List,
  OrganizationCommunityType,
  OrganizationType,
  PurgeCDNCacheContext,
  Subdomain,
  UserBackOfficeInfo,
  UserImpersonation,
} from "./data-contracts";

/**
 * No description
 * @tags backoffice
 * @name PurgeCloudflareCdnCache
 * @summary Purge Cloudflare's CDN cache by tags or hosts
 * @request POST:/backoffice/cdn-cache/purge
 * @secure
 */

// @ts-ignore
export const purgeCloudflareCDNCache: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {};
  RequestQuery: {};
  RequestBody: PurgeCDNCacheContext;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204;
} = {
  route: "/backoffice/cdn-cache/purge",
  method: "post",
  streaming: false,
  tags: ["backoffice"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name GetCustomDomainInfo
 * @summary Get Custom Domain info
 * @request GET:/backoffice/custom-domains/{hostname}
 * @secure
 */

// @ts-ignore
export const getCustomDomainInfo: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The custom hostname, for example "docs.gitbook.com" */
    hostname: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: CustomDomainInfo;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/backoffice/custom-domains/{hostname}",
  method: "get",
  streaming: false,
  tags: ["backoffice"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name HardDeleteCustomDomain
 * @summary Completely remove a Custom Domain from our DB and from Cloudflare
 * @request DELETE:/backoffice/custom-domains/{hostname}
 * @secure
 */

// @ts-ignore
export const hardDeleteCustomDomain: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The custom hostname, for example "docs.gitbook.com" */
    hostname: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/backoffice/custom-domains/{hostname}",
  method: "delete",
  streaming: false,
  tags: ["backoffice"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name CreateCloudflareHostname
 * @summary Create Cloudflare hostname entry for the custom domain.
 * @request PUT:/backoffice/custom-domains/{hostname}/cloudflare
 * @secure
 */

// @ts-ignore
export const createCloudflareHostname: {
  route: string;
  method: "put";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The custom hostname, for example "docs.gitbook.com" */
    hostname: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/backoffice/custom-domains/{hostname}/cloudflare",
  method: "put",
  streaming: false,
  tags: ["backoffice"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name RestartCloudflareHostnameValidation
 * @summary Restart Cloudflare hostname TLS validation for the custom domain.
 * @request PATCH:/backoffice/custom-domains/{hostname}/cloudflare
 * @secure
 */

// @ts-ignore
export const restartCloudflareHostnameValidation: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The custom hostname, for example "docs.gitbook.com" */
    hostname: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/backoffice/custom-domains/{hostname}/cloudflare",
  method: "patch",
  streaming: false,
  tags: ["backoffice"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name BlockPublicContentUrls
 * @summary Block public content by a list of public URLs
 * @request POST:/backoffice/blocks/public-urls
 * @secure
 */

// @ts-ignore
export const blockPublicContentUrls: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {};
  RequestQuery: {};
  RequestBody:
    | string[]
    | {
        /** A short description giving context on the reason for the block. */
        reason: BlockReason;
        blockPaidOrg?: boolean;
        /** @minItems 1 */
        urls: string[];
      };
  RequestHeaders: {};
  ResponseBody: {
    blocked: string[];
    failed: {
      url?: string;
      reason?: string;
    }[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/backoffice/blocks/public-urls",
  method: "post",
  streaming: false,
  tags: ["backoffice"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name GetUserBackOfficeInfo
 * @summary Get the GitBook User info shown in the BackOffice
 * @request GET:/backoffice/users/{userId}
 * @secure
 */

// @ts-ignore
export const getUserBackOfficeInfo: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: UserBackOfficeInfo;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/backoffice/users/{userId}",
  method: "get",
  streaming: false,
  tags: ["backoffice"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name ResetMfa
 * @summary Reset a user's MFA
 * @request DELETE:/backoffice/users/{userId}/mfa
 * @secure
 */

// @ts-ignore
export const resetMFA: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/backoffice/users/{userId}/mfa",
  method: "delete",
  streaming: false,
  tags: ["backoffice"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name BlockUser
 * @summary Block or Unblock a User
 * @request PATCH:/backoffice/users/{userId}/block
 * @secure
 */

// @ts-ignore
export const blockUser: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: BlockContext;
  RequestHeaders: {};
  ResponseBody: UserBackOfficeInfo;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/backoffice/users/{userId}/block",
  method: "patch",
  streaming: false,
  tags: ["backoffice"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name ImpersonateUser
 * @summary Impersonate a User
 * @request POST:/backoffice/users/{userId}/impersonate
 * @secure
 */

// @ts-ignore
export const impersonateUser: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: UserImpersonation;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/backoffice/users/{userId}/impersonate",
  method: "post",
  streaming: false,
  tags: ["backoffice"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name UserPermissions
 * @summary Returns user permissions
 * @request GET:/backoffice/users/{userId}/permissions
 * @secure
 */

// @ts-ignore
export const userPermissions: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Index;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/backoffice/users/{userId}/permissions",
  method: "get",
  streaming: false,
  tags: ["backoffice"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice, organizations
 * @name GetHideTrademarkForOrganizationById
 * @summary Get the hide trademark flag for an organization
 * @request GET:/backoffice/organizations/{organizationId}/trademark
 * @secure
 */

// @ts-ignore
export const getHideTrademarkForOrganizationById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    hideTrademark: boolean;
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/backoffice/organizations/{organizationId}/trademark",
  method: "get",
  streaming: false,
  tags: ["backoffice", "organizations"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice, organizations
 * @name ToggleHideTrademarkForOrganizationById
 * @summary Hide trademark or show it for an organization
 * @request PATCH:/backoffice/organizations/{organizationId}/trademark
 * @secure
 */

// @ts-ignore
export const toggleHideTrademarkForOrganizationById: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    hideTrademark: boolean;
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/backoffice/organizations/{organizationId}/trademark",
  method: "patch",
  streaming: false,
  tags: ["backoffice", "organizations"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name BlockOrganization
 * @summary Block or Unblock an Organization
 * @request PATCH:/backoffice/organizations/{organizationId}/block
 * @secure
 */

// @ts-ignore
export const blockOrganization: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: BlockContext;
  RequestHeaders: {};
  ResponseBody: {
    /** Whether the organization is blocked */
    blocked: boolean;
  };
  ResponseStatusCode: 200;
} = {
  route: "/backoffice/organizations/{organizationId}/block",
  method: "patch",
  streaming: false,
  tags: ["backoffice"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name SwitchOrganizationType
 * @summary Switch an Organization from Paid to Community or vice-versa
 * @request PATCH:/backoffice/organizations/{organizationId}/switch
 * @secure
 */

// @ts-ignore
export const switchOrganizationType: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody:
    | {
        type: "community";
        communityType: OrganizationCommunityType;
      }
    | {
        type: "business";
      };
  RequestHeaders: {};
  ResponseBody: {
    type: OrganizationType;
    communityType?: OrganizationCommunityType;
  };
  ResponseStatusCode: 200;
} = {
  route: "/backoffice/organizations/{organizationId}/switch",
  method: "patch",
  streaming: false,
  tags: ["backoffice"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Start a trial for an organization for a given number of days. Backoffice-only.
 * @tags backoffice, organizations
 * @name StartTrial
 * @summary Start a trial for an organization
 * @request POST:/backoffice/organizations/{organizationId}/trial
 * @secure
 */

// @ts-ignore
export const startTrial: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /**
     * Number of days for the trial period
     * @min 1
     */
    days: number;
    /** Force starting a trial even if an active subscription exists */
    force?: boolean;
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 205;
} = {
  route: "/backoffice/organizations/{organizationId}/trial",
  method: "post",
  streaming: false,
  tags: ["backoffice", "organizations"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name ListCustomHostnamesForOrganizationById
 * @summary List active and deprecated Custom Domains for an organization
 * @request GET:/backoffice/organizations/{organizationId}/custom-hostnames
 * @secure
 */

// @ts-ignore
export const listCustomHostnamesForOrganizationById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: CustomHostname[];
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/backoffice/organizations/{organizationId}/custom-hostnames",
  method: "get",
  streaming: false,
  tags: ["backoffice"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name ListSubdomainsForOrganizationById
 * @summary List active and deprecated subdomains for an organization
 * @request GET:/backoffice/organizations/{organizationId}/subdomains
 * @secure
 */

// @ts-ignore
export const listSubdomainsForOrganizationById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: Subdomain[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/backoffice/organizations/{organizationId}/subdomains",
  method: "get",
  streaming: false,
  tags: ["backoffice"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name UnblockSpace
 * @summary Unblock a Space
 * @request PATCH:/backoffice/spaces/{spaceId}/block
 * @secure
 */

// @ts-ignore
export const unblockSpace: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {};
  RequestBody: BlockContext;
  RequestHeaders: {};
  ResponseBody: {
    /** Whether the space is blocked */
    blocked: boolean;
  };
  ResponseStatusCode: 200;
} = {
  route: "/backoffice/spaces/{spaceId}/block",
  method: "patch",
  streaming: false,
  tags: ["backoffice"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name ReindexSpaceContentSearch
 * @summary Run a health check on the indexation of a space in the search engine. Run an indexation if needed.
 * @request POST:/backoffice/spaces/{spaceId}/content/index/search
 * @secure
 */

// @ts-ignore
export const reindexSpaceContentSearch: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/backoffice/spaces/{spaceId}/content/index/search",
  method: "post",
  streaming: false,
  tags: ["backoffice"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name ReindexSpaceContentAi
 * @summary Run an indexation of the content into the vector DB.
 * @request POST:/backoffice/spaces/{spaceId}/content/index/vectors
 * @secure
 */

// @ts-ignore
export const reindexSpaceContentAI: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/backoffice/spaces/{spaceId}/content/index/vectors",
  method: "post",
  streaming: false,
  tags: ["backoffice"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name ReindexSpaceContentReferences
 * @summary Run an indexation of the content references (links) in a space.
 * @request POST:/backoffice/spaces/{spaceId}/content/index/content-references
 * @secure
 */

// @ts-ignore
export const reindexSpaceContentReferences: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/backoffice/spaces/{spaceId}/content/index/content-references",
  method: "post",
  streaming: false,
  tags: ["backoffice"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name GetSiteBackOfficeInfo
 * @summary Get a site by its ID with no organization ID
 * @request GET:/backoffice/sites/{siteId}
 * @secure
 */

// @ts-ignore
export const getSiteBackOfficeInfo: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: BackOfficeSite;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/backoffice/sites/{siteId}",
  method: "get",
  streaming: false,
  tags: ["backoffice"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name PurgeSiteCache
 * @summary Purge a site's cache
 * @request DELETE:/backoffice/sites/{siteId}/cache
 * @secure
 */

// @ts-ignore
export const purgeSiteCache: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/backoffice/sites/{siteId}/cache",
  method: "delete",
  streaming: false,
  tags: ["backoffice"],
  criticalityLevel: "low",
  deprecated: false,
};
